import { Outlet, NavLink } from 'react-router-dom';
import { Home, Dumbbell, Salad, TrendingUp, User } from 'lucide-react';
import { useI18n } from '@/lib/i18n';
import { hasEntitlement } from '@/lib/api';

const items = [
  { to: '/app/home', icon: Home, key: 'tabs.home', tid: 'tab-home' },
  { to: '/app/training', icon: Dumbbell, key: 'tabs.training', tid: 'tab-training', ent: 'training_access' },
  { to: '/app/nutrition', icon: Salad, key: 'tabs.nutrition', tid: 'tab-nutrition', ent: 'nutrition_access' },
  { to: '/app/progress', icon: TrendingUp, key: 'tabs.progress', tid: 'tab-progress', ent: 'progress_access' },
  { to: '/app/profil', icon: User, key: 'tabs.profile', tid: 'tab-profil' },
];

export default function ClientLayout() {
  const { t } = useI18n();
  const visible = items.filter((it) => !it.ent || hasEntitlement(it.ent));
  return (
    <div className="min-h-screen bg-asgym-bg">
      <header className="sticky top-0 z-30 mx-auto flex w-full max-w-[480px] items-center border-b border-white/[0.06] bg-[#0B0C0E]/85 px-6 py-2.5 backdrop-blur-xl" data-testid="client-brand-header">
        <img src={`${process.env.PUBLIC_URL || ''}/assets/as-gym-logo.png`} alt="A'S GYM" className="h-7 w-auto object-contain mix-blend-screen" />
      </header>
      <div className="mx-auto min-h-screen w-full max-w-[480px] pb-28 relative">
        <Outlet />
      </div>
      <nav
        className="fixed bottom-0 left-1/2 z-40 flex w-full max-w-[480px] -translate-x-1/2 items-center justify-around border-t border-white/[0.06] bg-[#0B0C0E]/95 px-2 pb-[env(safe-area-inset-bottom)] pt-2 backdrop-blur-xl"
        data-testid="client-tabbar"
      >
        {visible.map(({ to, icon: Icon, key, tid }) => (
          <NavLink
            key={to}
            to={to}
            data-testid={tid}
            className={({ isActive }) =>
              `flex flex-1 flex-col items-center gap-1 rounded-xl py-2 text-[10px] font-bold tracking-wide transition-colors ${
                isActive ? 'text-asgym-accent' : 'text-asgym-muted hover:text-asgym-sub'
              }`
            }
          >
            {({ isActive }) => (
              <>
                <Icon size={22} strokeWidth={isActive ? 2.4 : 2} />
                {t(key).toUpperCase()}
              </>
            )}
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
